export var PLATFORM = {
  Advanced: 'advanced',
  MlSpace: 'mlspace',
  VmWare: 'vmware',
  Evolution: 'evolution',
  Test: 'test'
};
export var DEFAULT_PRICE = {
  priceHourNds: 0,
  priceDayNds: 0,
  priceMonthNds: 0,
  pricePartnersHourNds: 0,
  pricePartnersDayNds: 0,
  pricePartnersMonthNds: 0
};
export var CATEGORY = {
  Popular: 'popular',
  FreeTier: 'free-tier',
  Computations: 'computations',
  Network: 'network',
  Containerization: 'containerization',
  Storage: 'storage',
  Database: 'database',
  Development: 'development',
  Analytic: 'analytic',
  ML: 'ml-ai-tools'
};
export var DEFAULT_CATEGORY = CATEGORY.Popular;
export var CALCULATOR_DATA_TEST_ID = 'calculator';
export var WorkingHoursSpecification = /*#__PURE__*/function (WorkingHoursSpecification) {
  WorkingHoursSpecification["Hour"] = "hour";
  WorkingHoursSpecification["Day"] = "day";
  WorkingHoursSpecification["Month"] = "month";
  return WorkingHoursSpecification;
}({});
export var WORKING_HOURS_ITEMS = [{
  value: WorkingHoursSpecification.Month,
  label: 'Месяц'
}, {
  value: WorkingHoursSpecification.Day,
  label: 'День'
}, {
  value: WorkingHoursSpecification.Hour,
  label: 'Час'
}];